export default class Project {
  constructor(
    id = null,
    name = '',
    secretary = '',
    region = '',
    goal = '',
    impact = '',
    planLink = '',
    executionTime = '',
    prices = [],
    files = [],
    brief = '',
    email = '',
    // eslint-disable-next-line camelcase
    cc_sec_user = 0,
    validated = null,
  ) {
    this.id = id;
    this.name = name;
    this.secretary = secretary;
    this.region = region;
    this.goal = goal;
    this.impact = impact;
    this.planLink = planLink;
    this.executionTime = executionTime;
    this.prices = prices;
    this.files = files;
    this.brief = brief;
    this.email = email;
    // eslint-disable-next-line camelcase
    this.cc_sec_user = cc_sec_user;
    this.validated = validated;
  }
}
